function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_12225_36128)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.241 3.75562C12.4251 3.9397 12.4405 4.22863 12.2871 4.43023L12.2411 4.48292L8.72612 7.99905L12.2425 11.5155C12.4433 11.7163 12.4433 12.0419 12.2425 12.2427C12.0584 12.4269 11.7694 12.4422 11.5678 12.2889L11.5152 12.2428L7.99878 8.72639L4.48471 12.2424C4.28392 12.4433 3.95824 12.4435 3.75743 12.2426C3.57335 12.0586 3.5579 11.7696 3.71133 11.568L3.75734 11.5153L7.27156 7.99916L3.75713 4.48474C3.55631 4.28392 3.55635 3.9583 3.75719 3.75746C3.9413 3.57335 4.23025 3.55798 4.43183 3.71136L4.48447 3.7574L7.99889 7.27182L11.5137 3.75584C11.7145 3.55495 12.0402 3.55481 12.241 3.75562Z",
  fill: "#808080"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12225_36128"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.e1419ff7.svg";
export { ForwardRef as ReactComponent };